import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUnseenCelebrationEvents,
  markCelebrationSeen,
  markAllCelebrationsSeen,
} from "./CelebrationThunks";

const initialState = {
  events: [],
  loading: false,
  error: null,
};

const celebrationSlice = createSlice({
  name: "celebration",
  initialState,
  reducers: {
    triggerFirstReferralCelebration: (state) => {
      // Add a first referral event to trigger the celebration
      state.events = [
        {
          _id: `first_referral_${Date.now()}`,
          event_type: "first_referral",
          is_owner: true,
          display_data: {},
        },
        ...state.events,
      ];
    },
  },
  extraReducers: builder => {
    builder
      // Fetch unseen
      .addCase(fetchUnseenCelebrationEvents.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUnseenCelebrationEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.events = action.payload || [];
      })
      .addCase(fetchUnseenCelebrationEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Mark one seen
      .addCase(markCelebrationSeen.fulfilled, (state, action) => {
        state.events = state.events.filter(
          e => e._id !== action.payload
        );
      })

      // Mark all seen
      .addCase(markAllCelebrationsSeen.fulfilled, (state) => {
        state.events = [];
      });
  },
});

export const { triggerFirstReferralCelebration } = celebrationSlice.actions;
export default celebrationSlice.reducer;
